import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import './Experts.css';

interface Expert {
  id: number;
  name: string;
  role: string;
  image: string;
  description: string;
}

const Experts: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  const experts: Expert[] = [
    {
      id: 5,
      name: '李庆安',
      role: '专家顾问',
      image: '/images/liqingan.webp',
      description: '北京师范大学心理学院教授、博士生导师。发表学术论文60余篇。主持多项国家级教育研究课题。',
    },
    {
      id: 6,
      name: '李春红',
      role: '专家顾问',
      image: '/images/lichunhong.webp',
      description: '清华大学积极心理学研究中心深圳培训示范基地主任。深圳市健康管理研究会心理健康专委会会长。',
    },
    {
      id: 7,
      name: '吴明富',
      role: '专家顾问',
      image: '/images/wumingfu.webp',
      description: '美国联合大学跨领域整合研究艺术与科学—艺术治疗博士。台北市立大学视觉艺术研究所副教授。',
    },
    {
      id: 8,
      name: '吴薇莉',
      role: '专家顾问',
      image: '/images/wuweili.webp',
      description: '西华大学心理学教授。中国心理学会社区心理学专业委员会委员。高校大学生心理咨询专委会委员。',
    },
  ];

  return (
    <section id="experts" className="experts">
      <div className="experts-container" ref={ref}>
        <div className={`section-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">专家团队</h2>
          <p className="section-subtitle">
            汇聚国内外顶尖心理学专家，提供专业学术支持
          </p>
        </div>

        <div className="experts-grid">
          {experts.map((expert, index) => (
            <div
              key={expert.id}
              className={`expert-card ${isVisible ? 'visible' : ''}`}
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              <div className="expert-image-wrapper">
                <img src={expert.image} alt={expert.name} className="expert-image" />
              </div>
              <div className="expert-info">
                <h3 className="expert-name">{expert.name}</h3>
                <h4 className="expert-role">{expert.role}</h4>
                <p className="expert-description">{expert.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experts;
